var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, Switch } from 'react-router-dom';
import { createBrowserHistory } from 'history';
// import createHashHistory from 'history/createHashHistory';
import { Provider } from 'react-redux';
// import { createLogger } from 'redux-logger';
import './index.css';
import './index.scss';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
// kendo intl
import { IntlProvider, load, LocalizationProvider, loadMessages, } from '@progress/kendo-react-intl';
import likelySubtags from 'cldr-core/supplemental/likelySubtags.json';
import currencyData from 'cldr-core/supplemental/currencyData.json';
import weekData from 'cldr-core/supplemental/weekData.json';
import numbers from 'cldr-numbers-full/main/zh-Hant/numbers.json';
import caGregorian from 'cldr-dates-full/main/zh-Hant/ca-gregorian.json';
import dateFields from 'cldr-dates-full/main/zh-Hant/dateFields.json';
import timeZoneNames from 'cldr-dates-full/main/zh-Hant/timeZoneNames.json';
// notistack snackbar
import { SnackbarProvider } from 'notistack';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import twLocale from 'date-fns/locale/zh-TW';
import { blue } from '@material-ui/core/colors';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import InfoIcon from '@material-ui/icons/Info';
import CancelIcon from '@material-ui/icons/Cancel';
import WarningIcon from '@material-ui/icons/Warning';
import CloseIcon from '@material-ui/icons/Close';
// ================ i18n ==================
import { warningSnack } from 'component/config';
import IconButton from '@material-ui/core/IconButton';
import Loading from 'component/loading';
import store from 'reducers/configureStore';
import zhTW from 'component/material/DataGrid/zhTW';
import * as serviceWorker from './serviceWorker';
import twMessages from './kendoTW.json';
import indexRoutes from './routes';
// ================ material theme ================
var theme = createMuiTheme({
    palette: {
        primary: blue,
    },
    overrides: {
        MuiOutlinedInput: {
            root: {
                '&:hover': {
                    '& $notchedOutline': {
                        borderColor: '#1976d2',
                    },
                },
            },
        },
    },
}, zhTW);
// ================  ================
load(likelySubtags, currencyData, weekData, numbers, caGregorian, dateFields, timeZoneNames);
loadMessages(twMessages, 'tw-TW');
// ================ redux ================
// const logger = createLogger();
var history = createBrowserHistory();
// const history = createHashHistory();
var notistackRef;
ReactDOM.render(React.createElement(Provider, { store: store },
    React.createElement(Loading, null),
    React.createElement(LocalizationProvider, { language: "tw-TW" },
        React.createElement(IntlProvider, { locale: "zh-Hant" },
            React.createElement(MuiPickersUtilsProvider, { utils: DateFnsUtils, locale: twLocale },
                React.createElement(SnackbarProvider, __assign({}, warningSnack, { maxSnack: 3, iconVariant: {
                        success: React.createElement(CheckCircleIcon, { style: { paddingRight: '3px' } }),
                        error: React.createElement(CancelIcon, { style: { paddingRight: '3px' } }),
                        warning: React.createElement(WarningIcon, { style: { paddingRight: '3px' } }),
                        info: React.createElement(InfoIcon, { style: { paddingRight: '3px' } }),
                    }, anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, autoHideDuration: 10000, ref: function (ref) {
                        notistackRef = ref;
                    }, action: function (key) { return (React.createElement(IconButton, { onClick: function () { return notistackRef.closeSnackbar(key); }, color: "inherit" },
                        React.createElement(CloseIcon, null))); } }),
                    React.createElement(ThemeProvider, { theme: theme },
                        React.createElement(Router, { history: history },
                            React.createElement(Switch, null, indexRoutes.map(function (prop) { return (React.createElement(Route, { key: prop.path, path: prop.path, component: prop.component })); }))))))))), document.getElementById('root'));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
